import angular from "angular"
import RfpCoreUIModule from './ui/rfp.core.ui.module'

export default angular.module('rb.rfp.core', [
  RfpCoreUIModule.name
])
